// auth.guard.ts
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../services/user.service';
import { map, catchError, take } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard  {
    constructor(
        private authService: UserService,
        private router: Router
    ) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        const path = (state.url || '').split('?')[0];
        if (path === '' || path === '/') {
            return of(true);
        }
        return this.authService.checkAuthentication().pipe(
            take(1),
            map(authenticated => {
                if (authenticated) {
                    return true;
                }
                this.router.navigate(['/'], { queryParams: { returnUrl: state.url } });
                return false;
            }),
            catchError(() => {
                this.router.navigate(['/'], { queryParams: { returnUrl: state.url } });
                return of(false);
            })
        );
    }
}

